import { useActionState, useEffect, useRef } from "react"
import { createContactUs, State } from "../actions/contactUs"
import Input from "../../../components/input";
import FormError from "../../../components/form-error";
import Textarea from "../../../components/textarea";
import { Button } from "../../../components/button";


export default function ContactForm(){
    const formRef= useRef<HTMLFormElement>(null);
    const initialState: State = {
      message: null,
      errors: {},
      success: false,
      defaultValues: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
    };
    const [state,formAction, isPending] = useActionState(createContactUs,initialState);
    useEffect(() => {
        if(state.success)
            formRef.current?.reset();
    }, [state])
    const inputStyle="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";
    return  <div className="bg-white rounded-lg shadow-lg p-8 border border-blue-200">
                    <h2 className="text-2xl font-semibold text-purple-700 mb-6">Send Us a Message</h2>
                    <form ref={formRef} className="space-y-6 text-left" action={formAction}>
                        <div>
                            <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">Your Name</label>
                            <Input id="name" name="name" required    aria-describedby="name-error" placeholder="Enter your name" defaultValue={state.defaultValues?.name} className={inputStyle}></Input>
                            <FormError id="name-error" message={state.errors?.name} />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Your Email</label>
                            <Input id="email" name="email" required  type="email"  aria-describedby="email-error" placeholder="Enter your email" defaultValue={state.defaultValues?.email} className={inputStyle}></Input>
                            <FormError id="email-error" message={state.errors?.name} />
                        </div>
                        <div>
                            <label htmlFor="subject" className="block text-gray-700 text-sm font-bold mb-2">Subject</label>                            
                            <Input id="subject" name="subject" required  type="subject"  aria-describedby="subject-error" placeholder="Enter contact subject" defaultValue={state.defaultValues?.subject} className={inputStyle}></Input>
                            <FormError id="subject-error" message={state.errors?.name} />
                        </div>
                        <div>
                            <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">Message</label>
                            <Textarea id="message" name="message" required   rows={5} aria-describedby="message-error" placeholder="Enter your message" defaultValue={state.defaultValues?.subject} className={inputStyle}></Textarea>
                            <FormError id="message-error" message={state.errors?.name} />
                        </div>
                        <Button className="w-full " disabled={isPending}  >Send Message</Button>
                        {state.success && <p className="text-purple-500 text-center">{state.message}</p>}
                        {state.message && !state.success && <p className="text-red-500 text-center">{state.message}</p>}
                        
                    </form>
                </div>
}